import { render } from "./EnEstaSeccion.vue?vue&type=template&id=0b563934"
import script from "./EnEstaSeccion.vue?vue&type=script&lang=js"
export * from "./EnEstaSeccion.vue?vue&type=script&lang=js"

import exportComponent from "/proyectos/servicios/ide-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__